<template>
  <div class="teleInfos">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="name" :placeholder="type==1?'水表名称':'电表名称'"></el-input>
        </el-form-item>
        <el-button type="primary" @click="selectWaterElectricityList">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="addTel()">{{"添加"}}</el-button>
      <el-button type="primary" slot="header" @click="jump">{{$t('lang.btn_backpage')}}</el-button>
      <el-table :data="tableData" class="wid100"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="teleInfosListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="num"  :label="type==1?'水表编号':'电表编号'"></el-table-column>
        <el-table-column prop="name" :label="type==1?'水表名称':'电表名称'"></el-table-column>
        <el-table-column prop="price" :label="type==1?'水表单价':'电表单价'"></el-table-column>
        <el-table-column prop="multiple" :label="type==1?'水表仪表倍':'电表仪表倍'"></el-table-column>
        <el-table-column prop="degree" label="初始仪表度"></el-table-column>
         <el-table-column prop="base" :label="type==1?'水表转表基':'电表转表基'"></el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operate" :label="$t('lang.lab_operation')" fixed="right"
          :width="require('@/config/enum').opr_width4">
          <template slot-scope="scope">
            <el-button @click="changeTel(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="delTele(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
            <!-- <el-button class="orange" @click="transfer(scope.row)">{{$t('lang.lab_transfer')}}</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加页码 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!-- 添加弹框 -->
    <el-dialog :title="titleShow" :visible.sync="diaIsShow" :close-on-click-modal="false" center top="130px"
      width="600px" @closed="handleDialogClosed">
      <!-- 表单验证 -->
      <el-form :model="form" :rules="rules" ref="form" :label-width="require('@/config/enum').c_ws4"
        :label-suffix="require('@/config/enum').c_colon">
        <!-- 名称 -->
        <el-form-item :label="type==1?'水表编号':'电表编号'" prop="num">
          <el-input v-model="form.num" :placeholder="type==1?'水表编号':'电表编号'" maxlength="11"></el-input>
        </el-form-item>
          <el-form-item :label="type==1?'水表名称':'电表名称'" prop="name">
          <el-input v-model="form.name" :placeholder="type==1?'水表名称':'电表名称'" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item :label="type==1?'水表单价':'电表单价'" prop="price">
          <el-input v-model="form.price" :placeholder="type==1?'水表单价':'电表单价'" maxlength="11"></el-input>
        </el-form-item>
         <el-form-item :label="type==1?'水表仪表倍':'电表仪表倍'" prop="multiple">
          <el-input v-model="form.multiple" :placeholder="type==1?'水表仪表倍':'电表仪表倍'" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="初始仪表度" prop="degree">
          <el-input v-model="form.degree" placeholder="初始仪表度" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item :label="type==1?'水表转表基':'电表转表基'" prop="base">
          <el-input v-model="form.base" :placeholder="type==1?'水表转表基':'电表转表基'" maxlength="11"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clear()">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary"  @click="save('form')">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:teleInfo
   *@Description:添加仪表
   *@author:xbz
   *@Copyright:格众科技
   *@date:2020-03-13
   */
  import { mapGetters } from 'vuex'
  
  export default {
    data() {
          var choosehouseId = (rule, value, callback) => {
            console.log(this.ruleForm)
          if (this.ruleForm.houseId === '' || this.ruleForm.houseId === '0') {
            callback(
              new Error(
                this.$i18n.t('lang.lab_please_Select') +
                  this.$i18n.t('lang.diaFormhouse')
              )
            )
          } else {
            callback()
          }
        }
        var chooseunitId = (rule, value, callback) => {
          if (this.ruleForm.unitId === '' || this.ruleForm.unitId === '0') {
            callback(
              new Error(
                this.$i18n.t('lang.lab_please_Select') +
                  this.$i18n.t('lang.diaFormunit')
              )
            )
          } else {
            callback()
          }
        }
        var chooseroomId = (rule, value, callback) => {
          if (this.ruleForm.roomId === '' || this.ruleForm.roomId === '0') {
            callback(
              new Error(
                this.$i18n.t('lang.lab_please_Select') +
                  this.$i18n.t('lang.lab_theRoomNum')
              )
            )   
          } else {
            callback()
          }
        }
      return {
				roomId: '',
        ownerId: '',
        isDisabled: true, // 按钮置灰
        name: '', // 名称
        editId: '', // 接收参数
        titleShow: '', // 弹框标题
        diaIsShow: false, // 弹框是否显示
        pageNum: 1, // 页数
        pageSize: 10, // 每页数量
        pageCount: 0, // 总页数
        tableData: [], // 表单数据
        multipleSelection: [], // 多选框
        type: '', // 判断checkbox的值
        teleInfosListcheckbox: require('@/config/enum').teleInfosListcheckbox, // 是否隐藏复选框
        form: {
          num: '',
          name: '',
          price: '',
          multiple:'',
          id:'',
          degree:'',
          base:''
        },
        name: '',
        rules: {
          num: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input'),
            trigger: 'blur'
          }],
          name: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input'),
            trigger: 'blur'
          }],
          price: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input'),
            trigger: 'blur'
          }],
          multiple: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input'),
            trigger: 'blur'
          }],
          degree: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input'),
            trigger: 'blur'
          }],
          base: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input'),
            trigger: 'blur'
          }]
        },
        rulesTransfer: {
          houseId: [
            {
              required: true,
              validator: choosehouseId,
              trigger: 'change',
            },
          ],
          unitId: [
            {
            required: true,
              validator: chooseunitId,
              trigger: 'change',
            },
          ],
          roomId: [
            {
            required: true,
              validator: chooseroomId,
              trigger: 'change',
            },
          ]
      },
      }
    },
    // 初始化
    created() {
      this.ownerId = this.$route.query.row.id
			this.roomId = this.$route.query.row.roomId
      this.type = this.$route.query.type
      this.selectWaterElectricityList()
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    methods: {
      keyBA() {
        // 仅保留数字和"."
        this.form.totalNum = this.form.totalNum.replace(/[^\d]/g, '')
        // 首位是0的话去掉
        if (this.form.totalNum.indexOf('.') < 0 && this.form.totalNum != '') {
          this.form.totalNum = parseFloat(this.form.totalNum)
        }
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      // 列表斑马线
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      selectWaterElectricityList() {
        let loading = this.$loading()
        this.$get(
          `/waterElectricityList?ownerId=${this.ownerId}&name=${this.name}&type=${this.type}&pageNo=${this.pageNum}&pageSize=${this.pageSize}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      addTel() {
        this.editId = ''
        this.titleShow = "添加仪表"
        this.form.name = ''
        this.form.num =''
        this.form.price=''
        this.form.multiple=''
        this.form.degree=''
        this.form.base=''
        this.diaIsShow = true
      },
      changeTel(row) {
        this.form.id=''
        this.editId = row.id
        this.titleShow = "修改仪表"
        this.form.name = row.name
        this.form.num = row.num
        this.form.price = row.price
        this.form.multiple = row.multiple
        this.form.degree = row.degree
        this.form.base = row.base
        this.diaIsShow = true
      },
      // 删除
      delTele(id) {
        let loading = this.$loading()
        this.$confirm(
            this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          ).then(() => {
            this.$delete(`waterElectricityDel/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.selectWaterElectricityList()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 保存
      save(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.editId === '') {
              let params = {
                ownerId: this.ownerId,
								roomId: this.roomId,
                num: this.form.num,
                name: this.form.name,
                price: this.form.price,
                multiple: this.form.multiple,
                degree: this.form.degree,
                base: this.form.base,
                gardenId:this.$store.getters.gardenId,
                type:this.type
              }
              let loading = this.$loading()
              console.log(params)
              this.$post(`/waterElectricityAdd/`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.diaIsShow = false
                    this.selectWaterElectricityList()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              let loading = this.$loading()
              let params = {
                num: this.form.num,
                name: this.form.name,
                price: this.form.price,
                multiple: this.form.multiple,
                degree: this.form.degree,
                base: this.form.base,
              }
              this.$patch(`/waterElectricityUpdate/${this.editId}`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.diaIsShow = false
                    this.selectWaterElectricityList()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
              console.log(params.type)
            }
          }
        })
      },
      clear() {
        this.$refs.form.resetFields()
        this.form.name = ''
        this.form.totalNum = ''
        this.form.isRepeat = '1'
      },
      jump() {
        this.$router.push({
          name: 'preHouseholdInfoManageList'
        })
      },
      // 监听关闭dialog
      handleDialogClosed() {
        this.clear()
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNum = val
        this.selectWaterElectricityList()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.selectWaterElectricityList() 
      }
    }
  }
</script>

<style lang="scss">
</style>